import {Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {Otp} from './components/Otp'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='otp' element={<Otp />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
